import { useTheme } from '@mui/material';
import styles from '../../pages/chat/Chat.module.css';

const Footer = () => {
  const theme = useTheme()
  const bgColor = theme.palette.background.paper;
  const textColor = theme.palette.getContrastText(bgColor);
  return (
    <div className={styles.footerContainer} style={{
        backgroundColor: bgColor,
        color: textColor,
    }}>
        <p><u>Notice:</u></p>
      <p>
          The following content has been algorithmically generated by an AI system,
          for the Global Purchasing and Supply Chain (GPSC) organization,
          and is an informational tool designed to assist with GPSC processes and procedures.
          While we strive for accuracy and quality, please note that the information provided
          may not be entirely error-free or up-to-date.
          We recommend independently verifying the content and consulting with professionals
          for specific advice or information.
      </p>
    </div>
  );
};

export default Footer;